import React from 'react';

import ErrorPage from 'sow/components/templates/ErrorPageTemplate';

const ErrorForbiddenPage = () => (
  <ErrorPage message="You do not have permission to view this page." />
);

export default ErrorForbiddenPage;
